import { render, staticRenderFns } from "./visRegion.vue?vue&type=template&id=075545e7"
import script from "./visRegion.vue?vue&type=script&lang=js"
export * from "./visRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports